module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xdetail'), _vm._v(" "), _c('tohead')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d7d66e3e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d7d66e3e","hasScoped":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/router/pdate.vue
// module id = 245
// module chunks = 0